import {
  FormatBold,
  FormatItalic,
  FormatStrikethrough,
  FormatUnderlined,
  Link,
  Subscript,
  Superscript,
  VisibilityOff,
} from '@styled-icons/material';
import {
  MARK_BOLD,
  MARK_ITALIC,
  MARK_STRIKETHROUGH,
  MARK_SUBSCRIPT,
  MARK_SUPERSCRIPT,
  MARK_UNDERLINE,
} from '@udecode/plate-basic-marks';
import { LinkToolbarButton } from '@udecode/plate-ui-link';
import { MarkToolbarButton } from '@udecode/plate-ui-toolbar';
import { MobileTippy } from 'apps/exegesis/utils/components/MobileTippy';
import styled from 'styled-components';
import { HIDE_MARK } from './plugins/Hide/Hide';
export const ExcerptEditorToolbar = () => {
  return (
    <CustomHeadingToolbar>
      <MarkToolbarButton
        type={MARK_BOLD}
        icon={
          <MobileTippy
            placement="bottom"
            content="bold"
            arrow={false}
            offset={[0, 0]}
          >
            <FormatBold />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={MARK_ITALIC}
        icon={
          <MobileTippy
            placement="bottom"
            content="italic"
            arrow={false}
            offset={[0, 0]}
          >
            <FormatItalic />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={MARK_UNDERLINE}
        icon={
          <MobileTippy
            placement="bottom"
            content="underline"
            arrow={false}
            offset={[0, 0]}
          >
            <FormatUnderlined />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={HIDE_MARK}
        icon={
          <MobileTippy
            placement="bottom"
            content="hide"
            arrow={false}
            offset={[0, 0]}
          >
            <VisibilityOff />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={MARK_STRIKETHROUGH}
        icon={
          <MobileTippy
            placement="bottom"
            content="strikethrough"
            arrow={false}
            offset={[0, 0]}
          >
            <FormatStrikethrough />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={MARK_SUPERSCRIPT}
        icon={
          <MobileTippy
            placement="bottom"
            content="superscript"
            arrow={false}
            offset={[0, 0]}
          >
            <Superscript />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={MARK_SUBSCRIPT}
        icon={
          <MobileTippy
            placement="bottom"
            content="subscript"
            arrow={false}
            offset={[0, 0]}
          >
            <Subscript />
          </MobileTippy>
        }
      />
      <LinkToolbarButton
        icon={
          <MobileTippy
            placement="bottom"
            content="link"
            arrow={false}
            offset={[0, 0]}
          >
            <Link />
          </MobileTippy>
        }
      />
    </CustomHeadingToolbar>
  );
};

const CustomHeadingToolbar = styled.div`
  display: flex;
  /* align-items: center; */
  box-sizing: content-box;
  min-height: 30px;
  width: 100%;
  color: rgb(68, 68, 68);
  padding: 5px 8px 0px;
  /* border-bottom: 2px solid rgb(238, 238, 238); */
  flex-wrap: wrap;
  user-select: none;

  padding-left: 0px;
  padding-bottom: 0px;
  transition: opacity 0.5s;
  z-index: 100;

  & > .slate-ToolbarButton-active {
    color: ${(props) => props.theme.colors.link.text};
  }
`;
